export default __webpack_public_path__ + "static/paymentlink4-158ff21e8b845885e771f84c18641f1d.png";